import { useState } from "react";
import { trustPoints, faqList } from "@/mocks/home";

export default function TrustFaq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="bg-background-100/60 border-y border-background-200/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        {/* ===== 信任 / 信源规范 ===== */}
        <div id="trust" className="scroll-mt-24 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center mb-16 md:mb-20">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-3 py-1 text-xs font-semibold">
              <i className="ri-verified-badge-line"></i> 把瓜吃明白
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-black text-foreground-950 tracking-tight">
              热闹归热闹，分寸得守住
            </h2>
            <p className="mt-4 font-serif text-base md:text-lg leading-relaxed text-foreground-700">
              「爆料不等于实锤，热度不等于结论。我们替你把时间线捋直，把判断的权利留给你。」
            </p>
            <div className="mt-7 grid grid-cols-3 gap-3">
              {[
                { n: "3", l: "核验分级" },
                { n: "24h", l: "即时订正" },
                { n: "100%", l: "来源标注" },
              ].map((s) => (
                <div key={s.l} className="rounded-lg border border-background-200/60 bg-background-50 px-3 py-3.5 text-center">
                  <p className="text-xl font-black text-foreground-950">{s.n}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.l}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {trustPoints.map((p) => (
                <div
                  key={p.title}
                  className="rounded-lg border border-background-200/60 bg-background-50 p-5 hover:border-accent-300 transition"
                >
                  <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-800 flex items-center justify-center text-xl">
                    <i className={p.icon}></i>
                  </span>
                  <h3 className="mt-4 text-base font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ===== FAQ（醒目） ===== */}
        <div id="faq" className="scroll-mt-24 max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 text-secondary-900 px-3 py-1 text-xs font-semibold">
              <i className="ri-question-answer-line"></i> 第一次来？先看这里
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-black text-foreground-950 tracking-tight">
              常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              关于擦边吃瓜、核验标签与参与方式的 Q&amp;A，把疑虑先摊开聊聊。
            </p>
          </div>

          <div className="space-y-3">
            {faqList.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={`rounded-lg border bg-background-50 transition ${
                    isOpen ? "border-primary-300" : "border-background-200/60"
                  }`}
                >
                  <button
                    type="button"
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                  >
                    <span className="text-[15px] md:text-base font-bold text-foreground-950">{f.q}</span>
                    <span
                      className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition-transform duration-300 ${
                        isOpen ? "bg-primary-500 text-background-50 rotate-180" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-sm md:text-[15px] leading-relaxed text-foreground-600">
                      {f.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}